import styled from 'styled-components';

import { pxToRem } from 'utils/scss';

export const GoBackContainer = styled.div`
  display: flex;
  align-items: center;
  background: ${props => props.theme.colors.gradient.backButton};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  cursor: pointer;

  .icon-up {
    transform: rotate(270deg);
    background: ${props => props.theme.colors.gradient.backButton};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: ${pxToRem('16px')};
  }

  > span {
    margin-left: ${pxToRem('8px')};
    letter-spacing: ${pxToRem('1.4px')};
    text-transform: uppercase;
    cursor: inherit;
  }
`;
